import React, { useCallback, useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    IconButton,
    Slide,
    Typography,
    useMediaQuery, Drawer, SwipeableDrawer
} from '@mui/material';
import { Close } from '@mui/icons-material';
import { withStyles } from '@mui/styles';
import FileManager from "../FileManager";
import { defaultVariables } from "../../../../config/index";
import { Styles } from "../../../../config/design/styles";
import { translateKey } from "../../../../config/values";
import { useTheme } from '@mui/material/styles';
import {connect} from "trim-redux";

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const FileManagerDialog = ({
                               classes,
                               cancleOperation,
                               setImage,
                               setData,
                               preview,
                               single,
                               onlyFile,
                               selection,
                               fileType,
                               defined_width,
                               defined_height,
                               size = 200,
                               cover,
                               logo,
                               fourtotree,
                                isApp,
                               primary_color
                           }) => {
    const [open, setOpen] = useState(true);
    const theme = useTheme();
    const isDesktop = useMediaQuery(theme.breakpoints.up('md'));

    const img_ = cover ? "" : size > 400 ? "_medium" : "_small";
    const image_ = logo ? "_medium" : fourtotree ? (size > 400 ? "_thumbnail" : "_small") : img_;

    const handleSetImage = useCallback((data, previewValue = null) => {
        const res = {
            src: data.source,
            link: data.source_id ? `https://www.youtube.com/watch?v=${data.source_id}` : data.source,
            type: data.type,
            alt: data.alt,
            name: data.name,
            extension: data.extension,
            preview: previewValue || data.preview,
            id: data.id,
            thumbSource: `${defaultVariables.uploads}/FileManager/${data.name}${image_}.${data.extension}`
        };

        if (setData) {
            setData(data);
        } else {
            setImage(res);
        }
    }, [image_, setData, setImage]);

    const handleSetPreview = useCallback((data) => {
        if (setData) setData(data);
    }, [setData]);

    const handleClose = useCallback(() => {
        setOpen(false);
        cancleOperation();
    }, [cancleOperation]);

    const fileManagerComponent = (
        <FileManager
            preview={preview}
            modal
            single={single}
            onlyFile={onlyFile}
            selection={selection === true}
            fileType={fileType}
            handleSetImage={handleSetImage}
            handleSetPreview={handleSetPreview}
            defined_width={defined_width}
            defined_height={defined_height}
        />
    );

    return isDesktop ? (
        <Dialog
            className={!isApp && "dialog-app"}
            fullWidth
            maxWidth="lg"
            open={open}
            onClose={handleClose}
            TransitionComponent={Transition}
        >
            <DialogTitle className={classes.appBarDialog}>
                <Typography variant="h6" className={classes.titleDialog}>
                    {translateKey('chooseMedia')}
                </Typography>
                <IconButton
                    color="inherit"
                    onClick={handleClose}
                    aria-label="close"
                    className={classes.dialogClose}
                >
                    <Close />
                </IconButton>
            </DialogTitle>
            <DialogContent dividers>
                {fileManagerComponent}
            </DialogContent>
        </Dialog>
    ) : (
        <SwipeableDrawer
            anchor="bottom"
            open={open}
            onClose={handleClose}
            onOpen={() => {}}
            PaperProps={{
                style: {
                    borderTop: !!isApp ? "2px solid" : null,
                    borderTopColor: !!isApp ? primary_color : null,
                    maxHeight: '90vh',
                    overflowX: 'hidden',
                    overflowY: 'auto',
                }
            }}
        >
            <div style={{ padding: 16, position: 'relative' }}>
                <Typography variant="h6" style={{ marginBottom: 8 }}>
                    {translateKey('chooseMedia')}
                </Typography>
                <IconButton
                    onClick={handleClose}
                    aria-label="close"
                    style={{ position: 'absolute', right: 8, top: 8 }}
                >
                    <Close />
                </IconButton>
                <div style={{ marginTop: 10 }}>{fileManagerComponent}</div>
            </div>
        </SwipeableDrawer>
    );
};
const mstp = (state) => ({
    isApp: state.isApp,
    primary_color: state.primary_color,
});

export default withStyles(Styles)(connect(mstp)(FileManagerDialog));
